module.exports = __webpack_public_path__ + "static/KC_img-b593674b6eb50776376e62c521176fbb.jpg";